<template>
    <div class="card floating log" id="version-history">
      <div class="container-title">
        <h2>{{ action }}</h2>
        <button class="button button-close"
          @click="$store.commit('closeHovers')"
          :aria-label="$t('buttons.close')"
          :title="$t('buttons.close')">
          <img src="/img/icons/other-stuff/lnr-cross.svg">
        </button>
      </div>
      <div>
        <p v-if="data.node"><b>{{ $t('files.name') }}:</b> {{ data.node.name }}</p>
        <p v-else-if="data.currentNode"><b>{{ $t('files.name') }}:</b> {{ data.currentNode.name }}</p>
        <p v-if="currentName !== '' || loading"><b>{{ $t('prompts.nodeNameAfter') }}:</b> {{ loading ? $t('info.loading') : currentName }}</p>
        <p v-if="type !== ''"><b>{{ $t('prompts.nodeType') }}:</b> {{ nodeType }}</p>
        <p><b>{{ $t('prompts.dateRealization') }}:</b> {{ humanTime }}</p>
        <p><b>{{ $t('prompts.ip') }}:</b> {{ data.ip }}</p>
        <p><b>{{ $t('prompts.userAction') }}:</b> {{ email }}</p>
        <p><b>{{ $t('prompts.client') }}:</b> {{ humanUserAgent }}</p>
      </div>
    </div>
  </template>
  
<script>

import moment from 'moment';
import i18n from '@/i18n';
import { mapState } from 'vuex';

export default {
  name: 'show-info-log',
  props: ['data'],
  data: function () {
    return {
      loading: false,
      email: '',
      currentName: '',
      type: '',
      action: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),
    nodeType: function () {
      switch (this.type) {
        case Module.NodeType.SHARED_DRIVE_ROOT.value:
          return i18n.t('nodeType.sharedDrive');
        case Module.NodeType.FILE.value:
          return i18n.t('nodeType.file');
        case Module.NodeType.FOLDER.value:
          return i18n.t('nodeType.folder');
        case Module.NodeType.DEVICE.value:
          return i18n.t('nodeType.device');
        case Module.NodeType.BACKUP.value:
          return i18n.t('nodeType.backup');
        case Module.NodeType.SNAPSHOT.value:
          return i18n.t('nodeType.snapshot');  
        default: 
          return '';
      }
    },
    humanUserAgent: function () {
      if (!this.data.userAgent) {
        return i18n.t('settings.unknownUserAgent');
      }

      if (this.data.userAgent.startsWith('com.iberbox.android')) {
        return i18n.t('settings.androidUserAgent');
      }
      if (this.data.userAgent.startsWith('com.iberbox.ios')) {
        return i18n.t('settings.iosUserAgent');
      }
      else if (this.data.userAgent.startsWith('IberboxDesktop')) {
        if (this.data.userAgent.includes('macOS')) {
          return i18n.t('settings.desktopOnMacOsUserAgent');
        }
        else if (this.data.userAgent.includes('Windows')) {
          return i18n.t('settings.desktopOnWindowsUserAgent');
        }
        else if (this.data.userAgent.includes('Linux')) {
          return i18n.t('settings.desktopOnlinuxUserAgent');
        }
        else {
          return i18n.t('settings.desktopUserAgent');
        }
      }
      else if (this.data.userAgent.includes('Mozilla')) {
        if (this.data.userAgent.includes('iOS')) {
          return i18n.t('settings.webBrowserOnIOSOsUserAgent');
        }
        if (this.data.userAgent.includes('Android')) {
          return i18n.t('settings.webBrowserOnAndroidOsUserAgent');
        }
        if (this.data.userAgent.includes('Macintosh')) {
          return i18n.t('settings.webBrowserOnMacOsUserAgent');
        }
        else if (this.data.userAgent.includes('Windows')) {
          return i18n.t('settings.webBrowserOnWindowsUserAgent');
        }
        else if (this.data.userAgent.includes('Linux')) {
          return i18n.t('settings.webBrowserOnlinuxUserAgent');
        }
        else {
          return i18n.t('settings.webBrowserUserAgent');
        }
      }
      else if (this.data.userAgent.startsWith('IberboxTests')) {
        return 'Tests';
      }
      return i18n.t('settings.unknownUserAgent');
    },
    humanTime: function () {
      return moment(this.data.ctime * 1000).format('DD/MM/YYYY HH:mm:ss');
    },
  },
  async mounted () {
    switch (this.data.command) {
      case 'DOWM': 
        this.action = i18n.t('prompts.download');
        break;
      case 'RENM':
        this.action = i18n.t('buttons.update');
        break;
      case 'DENM':
        this.action = i18n.t('buttons.delete');
        break;
      case 'MONM':
        this.action = i18n.t('buttons.move');
        break;
      default: 
        this.action = '';
        break;
    }

    if (this.userInfo.handle === this.data.user) {
      this.email = this.userInfo.email; // Yourself
    } else {
      let action = await ibb.getPublicUserInfo(this.data.user);
      this.email = action.email;
    }

    if (this.data.node) {
      this.type = this.data.node.type;
    }

    if (this.data.currentNode) {
      this.currentName = this.data.currentNode.name;
      this.type = this.data.currentNode.type;
    } else {
      this.loading = true;
      let action = await ibb.getNodeById(this.data.handle);
      if (!action.error.type) {
        this.currentName = action.node.name;
        this.type = action.node.type;
      } else if (action.error.type === Module.ErrorType.E_NOTFOUND.value) {
        this.currentName = i18n.t('prompts.nodeNotFound');
      }
      this.loading = false;
    }

  },
  beforeDestroy () {
  },
  methods: {
  }
};
</script>